import { Injectable } from '@angular/core';
import { UiHelper } from '../helpers/ui.helper';
import lcData from './localCountryName.json';
import countryData from './allCountries.json';
import { LANGUAGES, DefaultLangCode, DefaultLangId } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  LANGID = 2;
  LANGCODE = 'en';
  LANGCODENABRR = 'en-US';
  TIMEZONE = 0;
  ISOABBR = 'gb';
  lcData;

  langDatas = {
    en: {
      langID: 2,
      langCode: 'en',
      langCodeNotAbrr: 'en-US',
      langNativeNames: '',
      ISOabbr: 'gb',
    },
    tr: {
      langID: 3,
      langCode: 'tr',
      langCodeNotAbrr: 'tr-TR',
      langNativeNames: '',
      ISOabbr: 'tr',
    },
    ar: {
      langID: 4,
      langCode: 'ar',
      langCodeNotAbrr: 'ar-IQ',
      langNativeNames: '',
      ISOabbr: 'iq',
    },
    de: {
      langID: 6,
      langCode: 'de',
      langCodeNotAbrr: 'de',
      langNativeNames: '',
      ISOabbr: 'de',
    },
    es: {
      langID: 7,
      langCode: 'es',
      langCodeNotAbrr: 'en',
      langNativeNames: '',
      ISOabbr: 'es',
    },
    fa: {
      langID: 8,
      langCode: 'fa',
      langCodeNotAbrr: 'en',
      langNativeNames: '',
      ISOabbr: 'fa',
    },
    ku: {
      langID: 10,
      langCode: 'ku',
      langCodeNotAbrr: 'ar-IQ',
      langNativeNames: '',
      ISOabbr: 'ku',
    },
    vi: {
      langID: 13,
      langCode: 'vi',
      langCodeNotAbrr: 'vi',
      langNativeNames: '',
      ISOabbr: 'vn',
    },
    fr: {
      langID: 14,
      langCode: 'fr',
      langCodeNotAbrr: 'fr',
      langNativeNames: '',
      ISOabbr: 'fr',
    },
    el: {
      langID: 15,
      langCode: 'el',
      langCodeNotAbrr: 'el',
      langNativeNames: '',
      ISOabbr: 'el',
    },
    ru: {
      langID: 5,
      langCode: 'ru',
      langCodeNotAbrr: 'ru',
      langNativeNames: '',
      ISOabbr: 'ru',
    },
    pl: {
      langID: 12,
      langCode: 'pl',
      langCodeNotAbrr: 'pl',
      langNativeNames: '',
      ISOabbr: 'pl',
    },
    bg: {
      langID: 17,
      langCode: 'bg',
      langCodeNotAbrr: 'bg',
      langNativeNames: '',
      ISOabbr: 'bg',
    },
    da: {
      langID: 19,
      langCode: 'da',
      langCodeNotAbrr: 'da',
      langNativeNames: '',
      ISOabbr: 'da',
    },
    ro: {
      langID: 18,
      langCode: 'ro',
      langCodeNotAbrr: 'ro',
      langNativeNames: '',
      ISOabbr: 'ro',
    },
    sq: {
      langID: 16,
      langCode: 'sq',
      langCodeNotAbrr: 'sq',
      langNativeNames: '',
      ISOabbr: 'sq',
    },
    pt: {
      langID: 11,
      langCode: 'pt',
      langCodeNotAbrr: 'pt',
      langNativeNames: '',
      ISOabbr: 'pt',
    },
    nl: {
      langID: 21,
      langCode: 'nl',
      langCodeNotAbrr: 'nl',
      langNativeNames: '',
      ISOabbr: 'nl',
    },
    mk: {
      langID: 23,
      langCode: 'mk',
      langCodeNotAbrr: 'mk',
      langNativeNames: '',
      ISOabbr: 'mk',
    },
    it: {
      langID: 22,
      langCode: 'it',
      langCodeNotAbrr: 'it',
      langNativeNames: '',
      ISOabbr: 'it',
    },
  } as object;
  tempLangDatas = {};
  supportedLangs = LANGUAGES;

  constructor(private _UiHelper: UiHelper) {
    this.supportedLangs.forEach(y => {
      Object.keys(this.langDatas).forEach(key => {
        this.langDatas[key].langNativeNames = lcData[this.langDatas[key].langCode].nativeName;

        if (key == y) {
          this.tempLangDatas[y] = this.langDatas[y];
          //////console.log(this.tempLangDatas);
        }
      });
    });

    this.langDatas = this.tempLangDatas;

    this.lcData = countryData;

    //  this.langDatas[this.LANGCODE].langNativeNames = lcData[this.LANGCODE].nativeName;

    this.init();
    // this.LANGCODE = navigator.language.substr(0, 2);
  }

  init() {
    //  According to client time setting.
    const d = new Date();
    this.TIMEZONE = d.getTimezoneOffset();

    if (localStorage.getItem('langcode') == undefined) {
      const langcodeNavigator = navigator.language.substr(0, 2);
      if (this.supportedLangs.includes(langcodeNavigator)) {
        //////console.log(this.LANGID);

        this.LANGCODE = langcodeNavigator;
        this.LANGID = this.langDatas[langcodeNavigator].langID;
        this.LANGCODENABRR = this.langDatas[langcodeNavigator]['langCodeNotAbrr'];
        this.ISOABBR = this.langDatas[langcodeNavigator]['ISOabbr'];
        localStorage.setItem('langcode', langcodeNavigator);
      } else {
        this.LANGID = DefaultLangId;
        this.LANGCODE = DefaultLangCode;
        this.LANGCODENABRR = this.langDatas[this.LANGCODE]['langCodeNotAbrr'];
        this.ISOABBR = this.langDatas[this.LANGCODE]['ISOabbr'];
        localStorage.setItem('langcode', DefaultLangCode);
      }
    } else {
      const storageLangCode = localStorage.getItem('langcode');
      if (this.langDatas[storageLangCode] != undefined) {
        this.LANGCODE = localStorage.getItem('langcode');
        this.LANGID = this.langDatas[localStorage.getItem('langcode')].langID;
        this.LANGCODENABRR = this.langDatas[localStorage.getItem('langcode')]['langCodeNotAbrr'];
        this.ISOABBR = this.langDatas[localStorage.getItem('langcode')]['ISOabbr'];
      } else {
        this.LANGID = DefaultLangId;
        this.LANGCODE = DefaultLangCode;
        this.LANGCODENABRR = this.langDatas[this.LANGCODE]['langCodeNotAbrr'];
        this.ISOABBR = this.langDatas[this.LANGCODE]['ISOabbr'];
        localStorage.setItem('langcode', DefaultLangCode);
      }
    }
  }

  changeLang(v: string) {
    this.LANGCODE = v;
    this.LANGID = this.langDatas[v].langID;
    localStorage.setItem('langcode', v);
    this.init();
    this._UiHelper.setRefreshApp();
  }
}
